export enum EAdminQueryKey {
  ADMIN_EXPRESSIONS = 'admin-expressions',
  ADMIN_EXPRESSION = 'admin-expression',
  ADMIN_SOURCES = 'admin-sources',
  ADMIN_SOURCE = 'admin-source',
  ADMIN_CLOZES = 'admin-clozes',
  ADMIN_STUDENT_METRICS = 'admin-student-metrics',
  ADMIN_DAILY_METRICS = 'admin-daily-metrics',
  ADMIN_OVERVIEW_METRIC = 'admin-overview-metric',
  ADMIN_EXPRESSION_METRIC = 'admin-expression-metric',
  ADMIN_CLOZE_METRIC = 'admin-cloze-metric',
  ADMIN_VOCABULARY_BOOKS = 'admin-vocabulary-books',
}
